import { render } from "./Anime.vue?vue&type=template&id=8d9bd178"
import script from "./Anime.vue?vue&type=script&lang=js"
export * from "./Anime.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__